import React from "react";
import { UpdateUserProfileType } from "../Types/userProfile";
import CreatePhotoURL from "./CreatePhotoURL";

interface IProps {
  userProfile: UpdateUserProfileType;
}

function UpdateUserPhotoURL(photoName: any) {
  var photoRef: string = "";
  if (photoName) {
    photoRef = CreatePhotoURL(photoName);
    //UserPhotoDownload();
    //photoRef = UserPhotoDownload("Fred3.jpg");
    console.log("UpdateUserPhotoURL satisfied and photoRef = ", photoRef);
    //console.log("userPhotoFileName= ", userPhotoFileName);
  } else {
    photoRef = CreatePhotoURL("photoURL.png");
    console.log("UpdateUserPhotoURL not satisfied and photoRef = ", photoRef);
    //console.log("userPhotoFileName= ", userPhotoFileName);
  }

  return photoRef;
}

export default UpdateUserPhotoURL;
